var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhoneColor = function SvgPhoneColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#phone-color_svg__a)",
    d: "M4.24 1.042c-.586 0-.879 0-1.167.07-.943.226-1.786 1.176-1.898 2.139-.035.295-.007.524.048.982.291 2.422.964 4.769 2.233 6.918a15.17 15.17 0 0 0 5.096 5.213c2.224 1.38 4.678 2.105 7.215 2.412.457.055.686.083.98.048.963-.112 1.915-.955 2.142-1.897.07-.289.07-.582.07-1.168 0-.518 0-.777-.043-1.006a2.5 2.5 0 0 0-1.415-1.811c-.21-.097-.463-.16-.966-.286l-.495-.124c-.977-.244-1.466-.366-1.949-.368a4 4 0 0 0-1.586.32c-.444.188-.848.49-1.655 1.094l-.19.144c-.64.478-.96.717-1.371.812-.321.074-.785.05-1.096-.057-.4-.137-.637-.356-1.111-.794q-.523-.483-.993-1.017c-.366-.417-.55-.625-.678-.972a2.24 2.24 0 0 1-.015-1.35c.121-.35.35-.622.807-1.165.644-.766.966-1.148 1.176-1.565a4 4 0 0 0 .428-1.852c-.005-.466-.124-.943-.363-1.895l-.1-.402c-.126-.504-.189-.755-.286-.966a2.5 2.5 0 0 0-1.811-1.415c-.229-.042-.488-.042-1.006-.042"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "phone-color_svg__a",
    x1: 1.042,
    x2: 18.958,
    y1: 10,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#580EB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6701A9"
  })))));
};
export default SvgPhoneColor;